<template>
	<div class="text-xs bg-grey-1 rounded-2xl max-w-217 p-6">
		<form @submit.prevent="changePasswordSubmit">
			<div class="form-group row">
				<label for="oldPassword" class="col-12 col-form-label text-left">Old Password</label>
				<div class="col-12">
					<input type="password" class="form-control" id="oldPassword" autocomplete="off" required
						v-model="oldPassword">
				</div>
			</div>
			<div class="form-group row">
				<label for="newPassword" class="col-12 col-form-label text-left">New Password</label>
				<div class="col-12">
					<input type="password" class="form-control" id="newPassword" autocomplete="off" required v-model="newPassword"
						@blur="outOfNewPassword = true">
					<code class="text-left" :style="{ display: displayNewPasswordError }">
							Password must be at least 8 characters and must contain at least 1 number.
						</code>
				</div>
			</div>
			<div class="form-group row">
				<label for="retypeNewPassword" class="col-12 col-form-label text-left">Retype New Password</label>
				<div class="col-12 text-left">
					<input type="password" class="form-control" id="retypeNewPassword" autocomplete="off"
						@click="retypePasswordValidation" @change="retypePasswordValidation" required v-model="retypeNewPassword">
					<code :style="{ display: displayRetypeNewPasswordError }">Password doesn't match!</code>
				</div>
			</div>

			<div>
				<button class="btn bg-theme h-10 min-w-28">Change Password</button>
			</div>
		</form>
	</div>
</template>

<script>
import axios from '@/api/axios.js'
import Swal from 'sweetalert2'

export default {
	name: 'SettingPassword',

	data() {
		return {
			oldPassword: '',
			newPassword: '',

			displayNewPasswordError: 'none',
			displayRetypeNewPasswordError: 'none',

			retypeNewPassword: '',

			outOfNewPassword: false,
		}
	},

	computed: {
	},

	watch: {
		newPassword() {
			if (this.outOfNewPassword && !this.passwordRegex.test(this.newPassword)) {
				this.displayNewPasswordError = 'initial'
			} else {
				this.displayNewPasswordError = 'none'
			}
		}
	},

	created() {
	},

	methods: {
		changePasswordSubmit() {
			const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/

			if (passwordRegex.test(this.newPassword)) {
				this.displayNewPasswordError = 'initial'

				Swal.fire({
					background: '#191f31',
					// title: '<span style="color: white;">Pre Order Trading Contract.</span>',
					html: '<span style="color: white;">Password must be at least 8 characters and must contain at least 1 number.</span>'
				})
			}
			else if (this.newPassword != this.retypeNewPassword) {
				this.displayRetypeNewPasswordError = 'initial'
			} else {
				Swal.fire({
					background: '#191f31',
					title: '<span style="color: white;">Are you sure want to change your password?</span>',
					imageWidth: 50,
					imageHeight: 50,
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes'
				}).then(async (result) => {
					if (result.value) {
						const oldPassword = await this.$store.dispatch('sha256', this.oldPassword)
						const newPassword = await this.$store.dispatch('sha256', this.newPassword)

						axios.post('/v2/igx/edit_password', {
							broker_id: this.$store.state.brokerId,
							password: oldPassword,
							new_password: newPassword
						}).then(response => {
							this.oldPassword = ''
							this.newPassword = ''
							this.retypeNewPassword = ''
							Swal.fire({
								background: '#191f31',
								type: 'success',
								title: '<span style="color: white;">Changed!</span>',
								html: '<span style="color: white;">Your password has been changed.</span>'
							})
						}).catch(error => {
							let err = error.response.data

							Swal.fire({
								background: '#191f31',
								type: 'error',
								title: '<span style="color: white;">Failed!</span>',
								html: `<span style="color: white;">${err.data.err_message}</span>`
							})
							console.error(error.message)
						})
					}
				})
			}
		},

		retypePasswordValidation() {
			// if (this.newPassword != this.retypeNewPassword) {
			// }else {
			// 	return 'initial'
			// }
			this.displayRetypeNewPasswordError = 'none'
		},
	},
}
</script>

<style scoped></style>